import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-date',
  templateUrl: './date.html',
  styleUrls: ['./date.scss']
})
export class DateComponent {
  
  @Input() date: Date;
  @Input() category: string;
  @Input() themeClass: string;

  constructor() { }

  getOrdinalNum(n) {
      const s = ['th', 'st', 'nd', 'rd'];
      const v = n % 100;
      return s[(v - 20) % 10] || s[v] || s[0];
  }
}
